import { FunctionComponent } from "react"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"
import { useNavigate } from "react-router-dom"

interface IScriptsCard {}
const ScriptsCard: FunctionComponent<IScriptsCard> = () => {
	const navigate = useNavigate()
	return (
		<Card>
			<Card.Header>Download Scripts</Card.Header>
			<Card.Body>
				<Card.Text>Download scripts for a specific building and router model.</Card.Text>
				<Button variant="primary" className="mt-3" onClick={() => navigate("scripts")}>
					Download
				</Button>
			</Card.Body>
		</Card>
	)
}
export default ScriptsCard
